import { partition, uniq } from 'lodash';
import { useMutation, UseMutationResult } from 'react-query';
import { matchIssuersByTerms } from '../../services/issuers/issuers.service';

interface UseMatchIssuersByTermsResult {
  matchedTags: string[];
  unMatchedTerms: string[];
}

export default (): UseMutationResult<UseMatchIssuersByTermsResult, void, string[], void> => {
  return useMutation(async (terms: string[]) => {
    const response = await matchIssuersByTerms(terms);
    const [matchedIssuers, unMatchedIssuers] = partition(response, (d) => !!d.match);
    return {
      matchedTags: uniq(matchedIssuers.map((issuer) => issuer.match!.tagId)),
      unMatchedTerms: unMatchedIssuers.map((issuer) => issuer.term),
    };
  });
};
